import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";

const performanceManagement = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getAllAppraisalDataAPI(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        };
        const query = JSON.stringify(values);
        const res = await fetch(
            `${config.host}/panel/pms/allAppraisalCycle?query=${query}`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

     async function getOneAppraisalCycleAPI(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        };
        // const query = JSON.stringify(values);
        const res = await fetch(
           `${config.host}/panel/pms/appraisalCycle?appraisalId=${values}`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

      async function updateStatusAPI(value) {
      try {
        const obj = {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
           body : JSON.stringify(value)
        };
        // const query = JSON.stringify(values);
        const res = await fetch(
           `${config.host}/panel/pms/updateStatus`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }


      async function updateAppraisalCycleAPI(value) {
      
        
      try {
                const obj = {
                  method: "Post",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                 body : JSON.stringify(value)
                };
                
        const res = await fetch(
           `${config.host}/panel/pms/updateAppraisalCycle`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

  return {
    getAllAppraisalDataAPI,
    getOneAppraisalCycleAPI,
    updateStatusAPI,
    updateAppraisalCycleAPI
  }

}

export default performanceManagement;